import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Storico ordini',
  labels: {
    dummy_order: 'Ordine di prova',
    orders_number: 'Numero di ordini ({{count}})',
    revenue: 'Ricavi: {{amount}}',
    tips: 'Mance: {{amount}}',
    cash_sales: ' ({{amount}} Contanti)',
    refunds: 'Rimborsi: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Ritiro',
    [OrderMethod.Delivery]: 'Consegna',
    [OrderMethod.OnSite]: 'Ordine al tavolo',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'In corso',
    [OrderFulfillmentStatus.Reviewed]: 'In corso',
    [OrderFulfillmentStatus.Accepted]: 'In corso',
    [OrderFulfillmentStatus.Preparing]: 'In corso',
    [OrderFulfillmentStatus.Ready]: 'In corso',
    [OrderFulfillmentStatus.OnDelivery]: 'In corso',
    [OrderFulfillmentStatus.Picked]: 'Completato',
    [OrderFulfillmentStatus.Rejected]: 'Rifiutato',
  },
  payment_methods: {
    invoice: 'Fattura',
    cash: 'Contanti',
    online: 'Metodo online',
  },
  filters: {
    all: 'Tutti',
  },
  fields: {
    order_placed: 'Ordine effettuato',
    order_number: '#',
    customer: 'Cliente',
    payment_method: 'Metodo di pagamento',
    method: 'Tipo',
    status: 'Stato',
    total: 'Totale',
  },
  buttons: {
    print: 'Stampa',
    create_test_order: 'Crea ordine di prova',
  },
  toasts: {
    failed_to_fetch_orders: 'Impossibile caricare i dati. Clicca sull’icona “aggiorna” o riprova tra 1 minuto.',
    something_went_wrong: 'Qualcosa è andato storto, riprova.',
    failed_to_create_test_order: "Impossibile creare l'ordine di prova",
    test_order_created: 'Ordine di prova creato',
  },
};
